<script setup lang="ts">
const { locale } = useI18n()

function getLocalizedFile(filePath: string, extension: string): string {
  return withHost(`${filePath}_${locale.value}${extension}`)
}
</script>

<template>
  <section class="container">
    <div class="flex flex-row px-4">
      <div class="lg:basis-7/8 mx-auto mt-14">
        <h2 class="font-pragmatica-ext mb-4 text-xl font-bold">
          {{ $t('forCustomers.customer-service.serviceTerms') }}
        </h2>
        <UiButtonDownload
          :file-path="
            getLocalizedFile(
              '/pdf/customer-service/service-terms-LD-Seating-2024',
              '.pdf'
            )
          "
          label-path="forCustomers.downloadAsPdf"
        />
        <h2 class="font-pragmatica-ext my-4 text-xl font-bold">
          {{ $t('forCustomers.customer-service.complaintForm') }}
        </h2>
        <UiButtonDownload
          :file-path="
            getLocalizedFile(
              '/pdf/customer-service/complaint-form-LD-Seating-2024',
              '.docx'
            )
          "
          label-path="forCustomers.downloadAsDocx"
        />

        <p class="mt-6 font-bold">
          {{ $t('forCustomers.customer-service.complaintTo') }}
          <NuxtLink :to="'mailto:' + $t('baseCommon.customerService.email')">
            {{ $t('baseCommon.customerService.email') }}
          </NuxtLink>
          .
        </p>
        <p
          v-if="$te('forCustomers.customer-service.appendix.infoBefore')"
          class="mt-2 font-bold"
          style="user-select: auto"
        >
          {{ $t('forCustomers.customer-service.appendix.infoBefore') }}
          <NuxtLink
            :to="'mailto:' + $t('forCustomers.customer-service.appendix.email')"
          >
            {{ $t('forCustomers.customer-service.appendix.email') }}
          </NuxtLink>
          {{ $t('forCustomers.customer-service.appendix.infoAfter') }}
        </p>
        <br />
        <ul class="ml-4 list-disc">
          <li>{{ $t('forCustomers.customer-service.details.first') }}</li>
          <li>{{ $t('forCustomers.customer-service.details.second') }}</li>
          <li>
            {{ $t('forCustomers.customer-service.details.third') }}
          </li>
        </ul>
        <br />
        <p>
          {{ $t('forCustomers.customer-service.nextSteps') }}
        </p>
      </div>
    </div>
    <div class="my-32"></div>
  </section>
</template>

<style scoped></style>
